import useStores from 'shared/hooks/use-stores';

import { usePaySignUpButton } from 'src/payments/components/pay-sign-up-button/use-pay-sign-up-button';
import { useDutchiePay, WhiteLabelConfig } from 'src/payments/hooks';

import { useCartPayment } from 'src/checkout/components/sections/payment/shared/use-cart-payment';

export type UsePayByBankSignupResponse = {
  pbbSignupEnabledForOrderType: boolean;
  pbbOnlyEnabledForOtherOrderTypes: boolean;
  handleClick: () => void;
  whiteLabelConfig: WhiteLabelConfig;
  otherOrderTypesWithPBBEnabled: string[];
};

export const LOCATION = 'ecomm-checkout-payment-section';

export const usePayByBankSignup = (): UsePayByBankSignupResponse => {
  // Hooks
  const { Cart, UI } = useStores();
  const { whiteLabelConfig } = useDutchiePay();

  const {
    otherOrderTypesWithPBBEnabled,
    hasOtherOrderTypesWithPBBEnabled,
    pbbSignupEnabledForOrderType,
  } = useCartPayment();

  const pbbOnlyEnabledForOtherOrderTypes = !pbbSignupEnabledForOrderType && hasOtherOrderTypesWithPBBEnabled;

  // Derived Vars
  const { variant = '' } = UI ?? {};
  const enrollmentSource = `checkout-page-${String(variant)}`;
  const cname = Cart.dispensary.cName;

  // Handlers
  const { handleClick } = usePaySignUpButton({
    location: LOCATION,
    cname,
    enrollmentSource,
  });

  return {
    pbbSignupEnabledForOrderType,
    pbbOnlyEnabledForOtherOrderTypes,
    whiteLabelConfig,
    otherOrderTypesWithPBBEnabled,
    handleClick,
  };
};
